<template>
  <div class="d-flex flex-column flex-root" v-loading="loading">
    <div class="d-flex flex-row flex-column-fluid page">
      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <div id="kt_content" class="d-flex flex-column flex-column-fluid">
          <!-- Header -->
          <div class="subheader subheader-solid" id="kt_subheader" v-if="isAuthenticated">
            <div
              class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
              v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
            ></div>
            <div class="align-items-center pr-5" style="display: flex">
              <el-dropdown trigger="click">
                <el-button type="default" style="padding: 8px 11px">
                  <div style="display: flex">
                    <el-avatar :size="25" :src="currentUser.avatar">
                      <el-avatar
                        class="w-100 h-100"
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                      ></el-avatar>
                    </el-avatar>
                    <span class="pl-2" style="line-height: 28px"
                      >{{ currentUser.unique_key_value
                      }}<i class="el-icon-arrow-down el-icon--right"></i
                    ></span>
                  </div>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    ><p @click="logout">
                      <i class="fas fa-sign-out-alt"></i>ログアウト
                    </p></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <!-- Body -->
          <div class="d-flex flex-column-fluid">
            <div
              :class="{
                'container-fluid': !contentFluid,
                container: contentFluid,
              }"
            >
              <transition name="fade-in-up">
                <div class="mt-8 card card-body" v-if="checkdataForm">
                  <h3 class="text-center mb-4">
                    <b>{{ label }}</b>
                  </h3>
                  <el-form
                    ref="ruleForm"
                    class="container-fluid p-xl-12 border-st2"
                    enctype="multipart/form-data"
                    id="form"
                  >
                    <div v-for="(value, key) of dataForm" :key="key">
                      <div
                        class="row mb-4"
                        :class="`${value.item_name}` ? value.item_name : ''"
                      >
                        <div class="col-md-2">{{ value.label_name }}</div>
                        <div class="col-md-6">
                          <el-form-item
                            v-if="
                              value.input_method == 2 ||
                              checkInputDate(value.validate_type)
                            "
                            :prop="value.item_name"
                            :key="key"
                          >
                            <el-date-picker
                              v-if="checkForm4"
                              v-model="dataForm[key].value"
                              type="year"
                              prefix-icon="el-icon-arrow-down"
                              clear-icon="hidden-icon-close"
                              :picker-options="pickerOptions"
                              :name="value.item_name"
                              format="yyyy"
                              value-format="yyyy"
                              @change="getAnswer"
                              :editable="false"
                            ></el-date-picker>
                            <el-date-picker
                              v-else-if="$route.params.form_child_url && answer_id"
                              v-model="dataForm[key].value"
                              type="month"
                              prefix-icon="el-icon-arrow-down"
                              clear-icon="hidden-icon-close"
                              :picker-options="pickerOptions"
                              :name="value.item_name"
                              format="yyyy-MM"
                              value-format="yyyy-MM"
                              @change="getAnswer"
                              :editable="false"
                            ></el-date-picker>
                            <el-date-picker
                              v-else
                              v-model="dataForm[key].value"
                              type="date"
                              :disabled="status == '0' || status == '1'"
                              prefix-icon="el-icon-arrow-down"
                              clear-icon="hidden-icon-close"
                              :picker-options="pickerOptions"
                              :name="value.item_name"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              :editable="false"
                            ></el-date-picker>
                            <p v-if="value.date_time">{{ value.date_time }}</p>
                            <p>
                              事業期間
                              <span v-if="dateForm || dateTo">
                                {{ chooseTime(dateForm) }} ~ {{ chooseTime(dateTo) }}
                              </span>
                            </p>
                          </el-form-item>
                          <el-form-item :prop="value.item_name" v-else>
                            <div v-if="value.input_method == 1">
                              <div
                                v-if="
                                  value.item_name == 'email' ||
                                  value.item_name == 'password'
                                "
                              >
                                <el-input
                                  :name="value.item_name"
                                  type="text"
                                  :disabled="checkFormAnswer || status == '0'"
                                  v-model.lazy="dataForm[key].value"
                                >
                                </el-input>
                              </div>
                              <el-input
                                v-else-if="
                                  checkForm3 ||
                                  checkForm2 ||
                                  value.item_name == 'contract_amount'
                                "
                                :name="value.item_name"
                                type="text"
                                @blur="
                                  dataForm[key].value = convertbyte(dataForm[key].value)
                                "
                                @change="
                                  dataForm[key].value = convertbyte(dataForm[key].value)
                                "
                                :key="key"
                                :disabled="status == '0' || status == '1'"
                                v-model.lazy="dataForm[key].value"
                              >
                              </el-input>
                              <el-input
                                v-else
                                :name="value.item_name"
                                type="text"
                                :disabled="status == '0' || status == '1'"
                                v-model="dataForm[key].value"
                              >
                              </el-input>
                            </div>
                            <div class="box-upload border" v-else>
                              <div class="banner-item">
                                <div class="box-16-9">
                                  <input
                                    :id="`file_${value.item_name}`"
                                    :key="value.item_name"
                                    :disabled="status == '0' || status == '1' || isUploading !== null"
                                    :v-model.lazy="dataForm[key].value"
                                    style="display: none"
                                    type="file"
                                    @change="uploadFile($event, key, value.item_name)"
                                    onclick="this.value=null;"
                                  />
                                  <label
                                    :for="`file_${value.item_name}`"
                                    class="file-drag"
                                  >
                                    <div class="start" >
                                      <div>
                                        <span
                                          :class="`file-upload-btn btn btn-primary ${( status == '0' || status == '1' || isUploading !== null)?'disabled':''}`"
                                          :style="{
                                            cursor:
                                              status == '0' || status == '1' || isUploading !== null
                                                ? 'no-drop'
                                                : '',
                                          }"
                                          >ファイルをアップロード</span
                                        >
                                        <span
                                          class="ml-4"
                                          v-if="image[`${value.item_name}_name`]"
                                          >{{ image[`${value.item_name}_name`] }}</span
                                        >
                                      </div>
                                    </div>
                                  </label>
                                </div>

                                <div v-show="isUploadChunk && isUploading===value.item_name" class="upload-chunk-progress">
                                    <div class="progress-bar progress-bar-striped bg-success"  :style="`width: ${uploadChunkProgress}%`">{{ uploadChunkProgress }}%</div>
                                </div>
                                <p class="el-form-item__error ml-1r" v-if="hasErrorFileMsg(value.item_name)">{{ getErrorFileMsg(value.item_name) }}</p>
                                <a :href="value.url_download" v-if="value.url_download">{{
                                  value.file_name
                                }}</a>
                              </div>
                            </div>
                           
                            <p v-if="value.date_time">{{ value.date_time }}</p>
                          </el-form-item>
                        </div>
                        <div class="d-flex align-items-center">
                          <el-button
                            v-if="
                              value.input_method == 3 &&
                              value.url_download &&
                              ![0, 1].includes(status)
                            "
                            type="danger"
                            icon="el-icon-delete"
                            circle
                            @click="openPopup(value, key)"
                          ></el-button>
                        </div>
                      </div>
                    </div>
                    <el-form-item class="text-center border-st2 pt-4">
                      <el-button
                        type="primary"
                        :disabled="status == '0' || status == '1' || checkButtonSubmit || isUploading !== null"
                        @click="submitForm()"
                        >入力完了</el-button
                      >
                    </el-form-item>
                    <input type="hidden" name="_csrf" v-model="form._csrf" />
                  </el-form>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Popup :id="popupId" :content="popupMessage">
      <b-button class="btn-primary" @click="deleteFileItem()"> はい </b-button>
      <b-button class="btn-primary" @click="$bvModal.hide(popupId)"> いいえ </b-button>
    </Popup>
    <Popup :id="popupFormId" :content="popupMessageNotChangeform">
      <b-button class="btn-primary" @click="$bvModal.hide(popupFormId)">
        閉じる
      </b-button>
    </Popup>
  </div>
</template>
<script>
import {
  LIST_FORM_BASE,
  CHECK_URL_FORM,
  GET_FORM_CHILD_BY_DATE,
  DELETE_FILE,
  UPLOAD_CHUNKS
} from "@/core/services/store/formBase.module";
import { mapActions, mapGetters } from "vuex";
import apiService from "@/core/services/api.service";
import moment from "moment";
import JwtService from "@/core/services/jwt.service";
import { LOGOUT, CALL_CSRF_TOKEN, getSCRFToken } from "@/core/services/store/auth.module";
import Popup from "@/view/components/Popup";
import {
  SUCCESS_MESSAGE,
  DELETE_MESSAGE,
  NOT_CHANGE_FORM,
  MESSAGE,
} from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
  components: {
    Popup,
  },
  data() {
    return {
      formClone: [],
      dataForm: [],
      dateForm: "",
      dateTo: "",
      pickerOptions: {
        disabledDate: this.disabledDueDate,
      },
      code: "",
      form_child_url: "",
      answer_id: "",
      token_user: "",
      api: "",
      status: "",
      tenant: "",
      loading: false,
      checkForm: false,
      checkForm2: false,
      checkForm3: false,
      checkForm4: false,
      checkForm6: false,
      checkFormAnswer: false,
      checkdataForm: false,
      label: "",
      dataOld: [],
      erorrFile: [],
      checkButtonSubmit: false,
      isUploading: null,
      image: {},
      popupId: "deletePopup",
      popupFormId: "popupFormId",
      popupMessage: DELETE_MESSAGE,
      popupMessageNotChangeform: NOT_CHANGE_FORM,
      selectedFile: null,
      selectedFileIndex: null,
      flagCheckChange: false,
      errorFilesMsg : {},
      form: {
        _csrf: "",
      },
    };
  },
  mounted() {},

  async created() {
    if (!getSCRFToken()) {
      await this.$store.dispatch(CALL_CSRF_TOKEN);
    }
    this.loading = true;
    if (this.$route.params.answer_id) {
      const token = JwtService.ID_TOKEN_KEY + "_" + this.$route.params.answer_id;
      apiService.setHeader(JwtService.getToken(token));
    } else {
      apiService.setHeader();
    }

    await this.getListInput();
    if (
      this.getListForm &&
      this.getListForm.url_list &&
      this.getListForm.url_list.form6
    ) {
      if (this.getListForm.url_list.form6 == this.$route.params.form_child_url) {
        await this.getAnswer(new Date().getDate());
      }
    } else if (this.$route.query.date && this.$route.params.form_child_url) {
      await this.getAnswer(this.$route.query.date);
    }
    this.form._csrf = getCsrfRandom();
    this.loading = false;
  },
  computed: {
    ...mapGetters([
      "layoutConfig",
      "getListForm",
      "currentUser",
      "getCheckForm",
      "getMessage",
      "getStatus",
      "isAuthenticated",
      "getUploadChunksProgress"
    ]),
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    uploadChunkProgress(){ return parseFloat(this.getUploadChunksProgress)},
    isUploadChunk(){
        const progress = parseFloat(this.getUploadChunksProgress)
        return progress < 100 && progress > 0
    }
  },
  methods: {
    ...mapActions([LIST_FORM_BASE, CHECK_URL_FORM, GET_FORM_CHILD_BY_DATE, DELETE_FILE, UPLOAD_CHUNKS]),
    async getListInput() {
      if (this.$route.params) {
        this.answer_id = this.$route.params.answer_id;
        this.code = this.$route.params.form_url;
        let data = { code: this.code, token: this.token_user, _csrf: this._csrf };
        if (this.$route.params.form_child_url) {
          data["answerId"] = this.answer_id;
          data["formUrlChild"] = this.$route.params.form_child_url;
        } else {
          this.label = "委託先管理";
        }
        if (this.$route.params.tenant) {
          this.tenant = this.$route.params.tenant;
        }
        const checkForm = { tenant: this.tenant, code: this.code };

        await this.checkUrlForm(checkForm);
        if (this.$route.params.form_child_url) {
          this.checkForm = true;
        } else {
          this.checkForm = this.getCheckForm;
        }
        if (this.getStatus == 200) {
          if (this.checkForm) {
            await this.listFormBase(data);
            if (this.getStatus == 200) {
              if (this.getListForm.form_item) {
                this.dataForm = this.getListForm.form_item.sort(function (a, b) {
                  return a.item_id - b.item_id;
                });
                this.formClone = JSON.parse(JSON.stringify(this.dataForm));
                this.dataForm.map((data) => {
                  if (data.item_name == "contract_amount") {
                    data.value = data.value
                      ? BigInt(
                          String(data.value).replace(/\D/g, ""),
                          10
                        ).toLocaleString("ja-JP", { currency: "JPY" })
                      : "";
                  }
                });
              }
              if (this.getListForm.form_answer) {
                this.checkFormAnswer = true;
              }
              if (this.getListForm.url_list && this.$route.params.form_child_url) {
                this.flagCheckChange = false;
                if (
                  this.getListForm.url_list.form2 == this.$route.params.form_child_url
                ) {
                  this.checkForm2 = true;
                  this.label = "予算報告";
                }
                if (
                  this.getListForm.url_list.form3 == this.$route.params.form_child_url
                ) {
                  this.checkForm3 = true;
                  this.label = "実績報告";
                }
                if (
                  this.getListForm.url_list.form4 == this.$route.params.form_child_url
                ) {
                  this.flagCheckChange = true;
                  this.checkForm4 = true;
                  this.label = "年次証憑";
                }
                if (
                  this.getListForm.url_list.form5 == this.$route.params.form_child_url
                ) {
                  this.flagCheckChange = true;
                  this.label = "月次証憑";
                }
                if (
                  this.getListForm.url_list.form6 == this.$route.params.form_child_url
                ) {
                  this.flagCheckChange = true;
                  this.checkForm6 = true;
                  this.label = "その他証憑申請";
                }
              }
              this.checkdataForm = true;
              if (!this.$route.params.form_child_url) {
                if (this.getListForm.form_answer) {
                  this.status = this.getListForm.form_answer.answer_status;
                }
              } else {
                this.status = this.getListForm.form_child_answer?.answer_status;
              }
              if (this.getListForm.m_hojojigyo) {
                this.dateForm = this.getListForm.m_hojojigyo.jigyo_kikan_from;
                this.dateTo = this.getListForm.m_hojojigyo.jigyo_kikan_to;
              }
            } else {
              if (this.getMessage) {
                this.notifyError(MESSAGE.FORM_URL_NOT_FOUND);
              }
            }
          }
        } else {
          if (this.getMessage) {
            this.notifyError(MESSAGE.FORM_URL_NOT_FOUND);
          }
        }
      }
    },
    disabledDueDate(date) {
      let dateForm;
      let dateTo;
      if (this.dateForm && this.dateTo) {
        if (this.form4) {
          dateTo = moment(this.dateTo).format("YYYY");
          dateForm = moment(this.dateForm).format("YYYY");
        } else if (this.$route.params.form_child_url && this.answer_id) {
          dateTo = moment(this.dateTo).format("YYYY-MM");
          dateForm = moment(this.dateForm).format("YYYY-MM");
        } else {
          dateForm = moment(this.dateForm);
          dateTo = moment(this.dateTo);
        }
        return !(
          moment(date).isSameOrAfter(dateForm) && moment(date).isSameOrBefore(dateTo)
        );
      }

      return false;
    },
    async submitForm() {
      this.$refs["ruleForm"].clearValidate();
      if (this.getObjectDiff(this.dataForm, this.formClone) && this.flagCheckChange) {
        this.$bvModal.show(this.popupFormId);
        return;
      }
      this.loading = true;

      let formData = new FormData();
      formData.append(`_csrf`, this.form._csrf);
      let valueNew;
      this.dataForm.forEach((value) => {
        let label_name = value.item_name;
        if (value.input_method == 2 || this.checkInputDate(value.validate_type)) {
          formData.append(`${label_name}`, value.value);
        } else {
          if (value.input_method == 3) {
            /** remove upload file, change by UploadChunk */
            // if (value.value instanceof File) {
            //   formData.append(`${label_name}`, value.value);
            // }
            formData.append(label_name, value.value);
          } else {
            if (this.checkForm3 || this.checkForm2 || label_name == "contract_amount") {
              valueNew = value.value ? value.value.replaceAll(",", "") : "";
              formData.append(`${label_name}`, valueNew);
            } else {
              formData.append(`${label_name}`, value.value);
            }
          }
        }
      });
      let url;
      if (this.answer_id && this.$route.params.form_child_url) {
        url = `user/form-base/user-answer-form-child/${this.code}/${this.answer_id}/${this.$route.params.form_child_url}`;
      } else {
        url = `user/form-base/user-answer-form/${this.tenant}/${this.code}`;
      }
      await apiService.post(url, formData).then(async (data) => {
          if (data && data.data && data.data.success) {
            this.notifySuccess(data.data.message);

            if (this.checkForm6 || !this.$route.params.form_child_url) {
              this.status = 0;
            }
            const date = this.dataForm[0]?.value;

            if (this.$route.params.form_child_url) {
              await this.getAnswer(date);
              this.status = this.getListForm?.form_answer?.answer_status;
            }
          } else {
            if (data && data.data.code == 422) {
              this.showErrorMessage(data.data.data, "ruleForm");
              if (data$data.data.data) {
                const firstIndex = document.getElementsByClassName(
                  `${Object.keys(data.data.data)[0]}`
                );
                if (firstIndex.length > 0) {
                  firstIndex[0].scrollIntoView({ block: "start", behavior: "smooth" });
                }
              }
            } else if (data && data.data.code == 403) {
              this.notifyError(data.data.message);
            } else {
              this.notifyError(data.data.message);
            }
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
        });

      this.loading = false;
    },

    async uploadFile(e, key, name) {
      try {
        this.errorFilesMsg[name] = null
        this.isUploading = name;

        const uploadParams = {
          file: e.currentTarget.files[0], 
          answer_id : this.answer_id,
          form_child_url : this.$route.params.form_child_url,
          type_upload:"answer",
        }
        const uploadRes = await this[UPLOAD_CHUNKS](uploadParams)
        this.dataForm[key].value = uploadRes.data.file_name
        this.image[`${name}_name`] = uploadRes.data.file_name;
        this.isUploading = null;
      } catch(e) {
        this.errorFilesMsg[name] = e.message
        this.isUploading = null;
      }
    },
    chooseTime(time) {
      let value;
      if (this.checkForm4) {
        value = moment(time).format("YYYY");
      } else if (this.$route.params.form_child_url && this.answer_id) {
        value = moment(time).format("YYYY-MM");
      } else {
        value = moment(time).format("YYYY-MM-DD");
      }
      return value;
    },
    checkInputDate(field) {
      if (field) {
        return field.split(",").includes("4");
      } else return false;
    },
    logout() {
      this.$confirm(
        "システムをログアウトしてもよろしいですか？",
        "委託管理システム・警報ダイアログ",
        {
          confirmButtonText: "はい",
          cancelButtonText: "いいえ",
          type: "warning",
        }
      )
        .then(() => {
          this.$store
            .dispatch(LOGOUT)
            .then((response) => {
              this.notifySuccess("システムを正常ログアウトしました。");
              let self = this;
              let param = {
                tenant: this.$route.params.tenant,
                form_url: this.$route.params.form_url,
              };
              let nameLogin;
              if (this.$route.params.form_child_url) {
                nameLogin = "loginUserChild";
                param.answer_id = this.$route.params.answer_id;
                param.form_child_url = this.$route.params.form_child_url;
              } else {
                nameLogin = "loginUser";
              }
              setTimeout(function () {
                self.$router.push({ name: nameLogin }, { params: param });
              }, 500);
            })
            .catch((err) => {
              this.notifyError(err.message);
            });
        })
        .catch((error) => {
          this.$message({
            type: "info",
            message: "Logout canceled",
          });
        });
    },
    async getAnswer(date) {
      this.$refs["ruleForm"].clearValidate();
      this.erorrFile = [];
      this.image = {};
      this.answer_id = this.$route?.params?.answer_id;
      this.code = this.$route?.params?.form_url;
      let data = {
        code: this.code,
        token: this.token_user,
        answerId: this.answer_id,
        formUrlChild: this.$route?.params?.form_child_url,
      };
      data["date"] = date;
      this.loading = true;
      await this.getFormChildByDate(data);
      if (this.getStatus == 200) {
        if (this.getListForm.form_item) {
          this.dataForm = this.getListForm.form_item.sort(function (a, b) {
            return a.item_id - b.item_id;
          });
          this.status = this.getListForm.form_child_answer?.answer_status;
          this.dataForm.map((data) => {
            if (data.input_method == 3) {
              this.image[`${data.item_name}_name`] = data.file_name;
            }
            if (data.input_method == 1 && data.value == "null") {
              data.value = null;
            }
            if (this.checkForm3 || this.checkForm2) {
              if (data.input_method == 1) {
                if (data.value) {
                  data.value = BigInt(
                    String(data.value).replace(/\D/g, ""),
                    10
                  ).toLocaleString("ja-JP", { currency: "JPY" });
                }
              }
            }
          });
          this.formClone = JSON.parse(JSON.stringify(this.dataForm));
        } else {
          await this.listFormBase(data);
          this.status = "";
          this.dataForm = this.getListForm.form_item.sort(function (a, b) {
            return a.item_id - b.item_id;
          });
          this.dataForm[0].value = date;
        }
      } else {
        if (this.getMessage) {
          this.notifyError(MESSAGE.FORM_URL_NOT_FOUND);
        }
      }
      this.loading = false;
    },
    getObjectDiff(obj1, obj2) {
      const str1 = JSON.stringify(obj1);
      const str2 = JSON.stringify(obj2);
      return str1 === str2;
    },
    openPopup(item, index) {
      this.selectedFile = item;
      this.selectedFileIndex = index;
      this.$bvModal.show(this.popupId);
    },
    async deleteFileItem() {
      this.$bvModal.hide(this.popupId);
      const answerIdChild = this.selectedFile.answer_child_id;
      const answerValueId = this.selectedFile.answer_value_id;

      const payload = {
        answerIdChild,
        answerValueId,
      };

      await this.deleteFile(payload);

      if (this.getStatus == 200) {
        this.notifySuccess(SUCCESS_MESSAGE);
        this.dataForm[this.selectedFileIndex].url_download = null;
        this.dataForm[this.selectedFileIndex].value = null;
        this.dataForm[this.selectedFileIndex].file_name = null;

        delete this.image[`${this.selectedFile.item_name}_name`];
      } else {
        this.notifyError(getMessage);
      }
    },
    convertbyte(money) {
      if (money) {
        for (let i = 0; i < money.length; i++) {
          if (money[i] < "0" || (money[i] > "9" && money[i] < "０") || money[i] > "９") {
            money = money.substring(0, i) + money.substring(i + 1);
            i--;
          }
        }
        money = this.fullWidthNumConvert(money);
        if (money) {
          return BigInt(money.replace(/\D/g, ""), 10).toLocaleString("ja-JP", {
            currency: "JPY",
          });
        }
      }
    },
    fullWidthNumConvert(fullWidthNum) {
      var ascii = "";
      for (var i = 0, l = fullWidthNum.length; i < l; i++) {
        var c = fullWidthNum[i].charCodeAt(0);
        if (c >= 0xff00 && c <= 0xffef) {
          c = 0xff & (c + 0x20);
        }

        ascii += String.fromCharCode(c);
      }

      return ascii;
    },
    hasErrorFileMsg(name){
      const msg = this.getErrorFileMsg(name)
      return msg && msg.length > 0
    },
    getErrorFileMsg(name){
      return this.errorFilesMsg[name]
    }
  },
};
</script>

<style lang="scss">
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.buton_cursor {
  cursor: no-drop;
}
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
.box-upload.border {
    position: relative;
}
.upload-chunk-progress {
    position: absolute;
    width: 100%;
    margin-top: 10px;

    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 1rem;
    overflow: hidden;
    line-height: 0;
    font-size: 0.75rem;
    background-color: #EBEDF3;
    border-radius: 0.42rem;
    -webkit-box-shadow: none;
    box-shadow: none;
    
    .progress-bar {
        background-repeat: repeat-x;
    }
}

.file-upload-btn.disabled {
  color: #FFF;
  background-color: #a0cfff;
  border-color: #a0cfff;
}
</style>
